import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useLoading} from "../../components/context/LoadingContext";
import {doc, getDoc, updateDoc} from "firebase/firestore";
import {db, reportsCollectionName} from "../../components/Firebase/Firebase";
import TextField from "@mui/material/TextField";
import {
    Button,
    FormControl,
    OutlinedInput,
    Select,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";

const ReportEditPage = () => {
    const {reportId} = useParams()
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useLoading();
    const [report, setReport] = useState(null);
    const [status, setStatus] = useState("new");

    useEffect(() => {
        const fetchReport = async () => {
            setIsLoading(true);
            try {
                const docRef = doc(db, reportsCollectionName, reportId);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const reportData = { id: docSnap.id, ...docSnap.data() };
                    setReport(reportData);
                    setStatus(reportData.status || "new");
                } else {
                    console.error("Документ не найден");
                    navigate('/reports');
                }
            } catch (error) {
                console.error("Ошибка загрузки документа:", error);
            }
            setIsLoading(false);
        };

        fetchReport();
    }, [reportId]);

    const handleStatusChange = (e) => {
        setStatus(e.target.value);
    };

    const handleUpdateReport = async () => {
        if (!report) return;

        setIsLoading(true);
        try {
            const docRef = doc(db, reportsCollectionName, reportId);
            await updateDoc(docRef, { status });
            console.log("Статус обновлен успешно!");
            navigate('/reports');
        } catch (error) {
            console.error("Ошибка обновления статуса:", error);
        }
        setIsLoading(false);
    };

    return (
        <div className='right-content'>
            <form onSubmit={(e) => {
                e.preventDefault();
                handleUpdateReport();
            }}>
                <div className='card shadow border-0'>
                    <div className='form-group'>
                        <h4 className='hd'>Обращение: {reportId}</h4>
                    </div>
                    <div style={{marginTop: 10}}>
                        <h5>Статус:</h5>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <FormControl
                            className="w-auto"
                            sx={{
                                minWidth: 200,
                                marginRight: 5,
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#CEFC4C',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#CEFC4C',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#CEFC4C',
                                    },
                                },
                            }}
                        >
                            <Select
                                value={status}
                                onChange={handleStatusChange}
                                input={<OutlinedInput/>}
                                sx={{
                                    color: '#fff',
                                    '& .MuiSvgIcon-root': {
                                        color: '#fff',
                                    },
                                }}
                            >
                                <MenuItem value="new">Новое</MenuItem>
                                <MenuItem value="inProgress">В работе</MenuItem>
                                <MenuItem value="done">Обработано</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <TextField
                        style={{marginTop: 20}}
                        className='w-25'
                        value={report ? new Date(report.createdAt).toLocaleDateString() : ''}
                        label="Дата обращения"
                        InputProps={{
                            readOnly: true,
                        }}
                        sx={textFieldStyles}
                    />
                    <TextField
                        style={{marginTop: 20}}
                        className='w-25'
                        value={report ? report.email : ''}
                        label="Почта пользователя"
                        InputProps={{
                            readOnly: true,
                        }}
                        sx={textFieldStyles}
                    />
                    <TextField
                        style={{ marginTop: 20 }}
                        className='w-100'
                        value={
                            report
                                ? `${report.deviceModel || 'Неизвестно'} / ${report.platform || 'Неизвестно'} ${report.systemVersion || 'Неизвестно'} / Версия приложения: ${report.appVersion || 'Неизвестно'}`
                                : ''
                        }
                        label="Информация об устройстве"
                        InputProps={{
                            readOnly: true,
                        }}
                        sx={textFieldStyles}
                    />

                    <TextField
                        style={{marginTop: 20}}
                        className='form-group w-100'
                        value={report ? report.text : ""}
                        label="Текс обращения"
                        multiline
                        sx={textFieldStyles}
                    />
                    <Button
                        className='logInButton w-100'
                        variant="contained"
                        component="label"
                        type="submit"
                        onClick={handleUpdateReport}
                    >
                        Сохранить
                    </Button>
                </div>
            </form>
        </div>
    );
};

const textFieldStyles = {
    '& .MuiSvgIcon-root': {
        color: '#fff',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#CEFC4C',
        },
        '&:hover fieldset': {
            borderColor: '#CEFC4C',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#CEFC4C',
        },
        '& input': {
            color: '#fff',
        },
        '& textarea': {
            color: '#fff',
        },
    },
    '& .MuiInputLabel-root': {
        color: '#fff',
        '&.Mui-focused': {
            color: '#fff',
        },
    },
};

export default ReportEditPage;